<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="24">
            <a-form-item label="关键字">
              <a-input v-model="queryParam.keywords" allowClear placeholder="搜索关键字"/>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="场次">
              <a-cascader :show-search="{ sjsqFilter }" :options="sjsqOptions"
                          :fieldNames="{ label: 'name', value: 'id', children: 'children' }" placeholder="请选择赛区"
                          v-model="queryParam.sjsq" changeOnSelect/>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="状态">
              <a-select v-model="queryParam.memberstatus" placeholder="请选择"
                        allowClear>
                <a-select-option value="1">联系人信息</a-select-option>
                <a-select-option value="2">人员信息</a-select-option>
                <a-select-option value="3">申报信息</a-select-option>
                <a-select-option value="10">论文科报会申报</a-select-option>
                <a-select-option value="20">校局长论坛申报</a-select-option>
                <a-select-option value="30">七彩星级申报</a-select-option>
                <a-select-option value="31">七彩星级国培申报</a-select-option>
                <a-select-option value="41">导师申报</a-select-option>
                <a-select-option value="4">确认订单</a-select-option>
                <a-select-option value="6">报名成功</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <template v-if="advanced">
            <a-col :md="6" :sm="24">
              <a-form-item label="开票审核">
                <r-switch :formData="queryParam" field="kaipiao_status" :checkedValue="1" :unCheckedValue="0"
                          checkedChildren="待审核" unCheckedChildren="不限"/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="省市">
                <a-cascader :options="areaOptions" placeholder="请选择地区" v-model="queryParam.namekeys" changeOnSelect
                />
              </a-form-item>
            </a-col>

            <a-col :md="6" :sm="24">
              <a-form-item label="商户订单号">
                <a-input v-model="queryParam.out_trade_no" allowClear placeholder="搜索商户订单号"/>
              </a-form-item>
            </a-col>

            <a-col :md="6" :sm="24">
              <a-form-item label="退款状态">
                <a-select v-model="queryParam.refund_status" placeholder="请选择"
                          allowClear>
                  <a-select-option value="1">未申请</a-select-option>
                  <a-select-option value="2">申请中</a-select-option>
                  <a-select-option value="3">退款成功</a-select-option>
                  <a-select-option value="4">不处理</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>

            <a-col :md="6" :sm="24">
              <a-form-item label="支付状态">
                <a-select v-model="queryParam.pay_status" placeholder="请选择"
                          allowClear>
                  <a-select-option value="1">未支付</a-select-option>
                  <a-select-option value="2">支付成功</a-select-option> 
                </a-select>
              </a-form-item>
            </a-col>

          </template>
          <a-col :md="!advanced && 6 || 24" :sm="24">
            <span class="table-page-search-submitButtons"
                  :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
              <a-button type="primary" @click="onSearch">查询</a-button>
              <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
              <a @click="toggleAdvanced" style="margin-left: 8px">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <div class="table-operator">

      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item @click="applyDeleteAll()" key="1">
            <a-icon type="delete"/>
            删除
          </a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作
          <a-icon type="down"/>
        </a-button>
      </a-dropdown>
      <a-button @click="download(1)" style="margin-left: 8px">
        报名信息表
        <a-icon type="download"/>
      </a-button>

      <a-button @click="download(2)" style="margin-left: 8px">
        人员信息表
        <a-icon type="download"/>
      </a-button> 

        <a-button @click="onSendMsg({
          sjsq:queryParam.sjsq 
        })">
          批量发送入群短信 
        </a-button>
      <!-- <a-button @click="download(3)" style="margin-left: 8px">
        331人员信息表
        <a-icon type="download"/>
      </a-button> -->

      <a-button @click="download(9)" style="margin-left: 8px">
        发票明细表
        <a-icon type="download"/>
      </a-button>
      <!--          <a-button  @click="download(7)">奖杯贴信息表-->
      <!--            <a-icon type="download"/>-->
      <!--          </a-button>-->
      <a-upload
          name="file"
          accept=".xlsx"
          action
          :before-upload="beforeFapiaoUpload"
          style="margin-left: 8px;margin-top: 8px;display: inline-block"
      >
        <a-button>
          批量导入发票
          <a-icon type="upload"/>
        </a-button>
      </a-upload>
      <a-upload
          name="file"
          accept=".csv"
          action
          :before-upload="beforeUpload"
          style="margin-left: 8px"
      >
        <a-button>
          成绩导入
          <a-icon type="upload"/>
        </a-button>
      </a-upload> 
      <a-upload
          name="file"
          accept=".xlsx"
          action
          :before-upload="beforeApplyUpload"
          style="margin-left: 8px"
      >
        <a-button>
          报名记录导入
          <a-icon type="upload"/>
        </a-button>
      </a-upload>
 
    </div>

    <s-table
        ref="table"
        size="default"
        :columns="columns"
        :data="loadData"
        :alert="{ show: true, clear: () => { this.selectedRowKeys = [] } }"
        :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
    >
      <span slot="danwei" slot-scope="text,record">
          <div style="margin-left: 10px; float: left">
            {{ record.danwei }}
            <br/>
            <a-tag v-if="record.pay_type_name" color="cyan">
            {{ record.pay_type_name }}
              </a-tag>
            <span style="color: #999">{{ record.ldname }} 人数 {{ record.membercount }}</span>
            <br/>
            {{ record.create_time|timeFormat }}
            <br/>
          </div>
      </span>
      <span slot="saiqu" slot-scope="text,record">
        {{ record.saiqu_name }}
      </span>
      <span slot="status" slot-scope="text,record">
        <a-tag v-if="record.memberstatus==1">联系人信息</a-tag>
        <a-tag v-if="record.memberstatus==2">人员信息</a-tag>
        <a-tag v-if="record.memberstatus==3">申报信息</a-tag>

        <a-tag v-if="record.memberstatus==10">论文科报会申报</a-tag>
        <a-tag v-if="record.memberstatus==20">校局长论文申报</a-tag>
        <a-tag v-if="record.memberstatus==30">七彩星级申报</a-tag>
        <a-tag v-if="record.memberstatus==31">七彩星级国培申报</a-tag>
        <a-tag v-if="record.memberstatus==41">导师申报</a-tag>

        
        <a-tag v-if="record.memberstatus==4" color="red">确认订单</a-tag>
        <a-tag v-else-if="record.memberstatus==6" color="green">报名成功</a-tag>
        <br/>
        <a-tag v-if="record.pay_status==1">未支付</a-tag>
        <a-tag v-else-if="record.pay_status==2" color="blue">已付款</a-tag>
        <br/>
        <a-tag v-if="record.refund_status==2" color="red">申请退款</a-tag>
        <br/>
        <a-tag v-if="record.refund_price>0" color="purple">有退款¥{{ record.refund_price }}</a-tag>

      </span>
      <span slot="action" slot-scope="text,record">
        <template>
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical"/>
          <a @click="handleOrderEdit(record)">缴费信息</a>
          <a-divider type="vertical"/>
          <a-popconfirm title="删除后不可恢复,确定删除吗?" @confirm="applyDelete(record)" okText="确定" cancelText="取消">
            <a href="javascript:;">删除</a>
          </a-popconfirm><br/>
          <a @click="onSendMsg({
            baoming_id:record.id,
            sjsq:[]
          })">发送入群短信</a> 
        </template>
      </span>
    </s-table>


    <a-modal
        :maskClosable="false"
        title="操作"
        :width="1200"
        :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
        v-model="visible"
        @ok="handleOk"
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form">
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="单位"
                  hasFeedback
              >
                <a-input v-model="formData.danwei"
                         placeholder="请输入单位名称"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="联系人"
                  hasFeedback
              >
                <a-input v-model="formData.ldname"
                         placeholder="请输入联系人"/>
              </a-form-item>

            </a-col>
          </a-row>
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="微信号"
                  hasFeedback
              >
                <a-input v-model="formData.weixin"
                         placeholder="请输入微信号"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="手机号"
                  hasFeedback
              >
                <a-input v-model="formData.phone"
                         placeholder="请输入手机号"/>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="邮箱"
                  hasFeedback
              >
                <a-input v-model="formData.email"
                         placeholder="请输入邮箱"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
            </a-col>
          </a-row>
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="省市"
                  hasFeedback
              >
                <a-cascader :options="areaOptions" placeholder="请选择地区" v-model="formData.areas" changeOnSelect/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="地址"
                  hasFeedback
              >
                <a-input v-model="formData.address"
                         placeholder="请输入详细地址"/>
              </a-form-item>
            </a-col>
          </a-row>

 

          <a-col :md="48" :sm="24">
            <a-form-item
                :labelCol="{
          xs: { span: 12 },
          sm: { span: 4 }}"
                :wrapperCol="{
          xs: { span: 24 },
          sm: { span: 12 }}"
                label="报名状态"
                hasFeedback
            >
              <a-radio-group v-model="formData.memberstatus" button-style="solid">
                <a-radio-button :value="1">
                  联系人信息
                </a-radio-button>
                <a-radio-button :value="2">
                  人员信息
                </a-radio-button>
                <a-radio-button :value="3">
                  申报信息
                </a-radio-button>

 
                <a-radio-button :value="10">
                  论文科报会申报
                </a-radio-button>
                <a-radio-button :value="20">
                  校局长论文申报
                </a-radio-button>
                <a-radio-button :value="30">
                  七彩星级申报
                </a-radio-button>
                
                <a-radio-button :value="31">
                  七彩星级国培申报
                </a-radio-button>

                <a-radio-button :value="41">
                  导师申报
                </a-radio-button>
                
                <a-radio-button :value="4" :disabled="formData.memberstatus==1">
                  确认订单
                </a-radio-button>
                <a-radio-button :value="6" :disabled="formData.memberstatus==1">
                  报名成功
                </a-radio-button>



              </a-radio-group>

            </a-form-item>
          </a-col>
          </a-row>

          <a-divider>论文科报会</a-divider>

          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="身份"
                  hasFeedback
              >
              <a-radio-group v-model="formData.lunwen_type" button-style="solid">
                <a-radio-button value="本科生">
                  本科生
                </a-radio-button>
                <a-radio-button value="研究生">
                  研究生
                </a-radio-button>  
              </a-radio-group>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="论文题目"
                  hasFeedback
              >
                <a-input v-model="formData.lunwen_title"
                         placeholder=""/>
              </a-form-item>
            </a-col>
          </a-row>


          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="大摘要"
                  hasFeedback
              > 
              <file-uploader
                      :file-list="formData.lunwen_dazhaiyao"
              />
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="论文文件"
                  hasFeedback
              >
              <file-uploader
                      :file-list="formData.lunwen_content"
              />
              </a-form-item>
            </a-col>
          </a-row>


          <a-divider>校局长论坛</a-divider>

          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="是否授牌"
                  hasFeedback
              >
              <a-radio-group v-model="formData.luntan_shoupai" button-style="solid">
                <a-radio-button value="是">
                  是
                </a-radio-button>
                <a-radio-button value="否">
                  否
                </a-radio-button>  
              </a-radio-group>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="离会时间"
                  hasFeedback
              >
                <a-input v-model="formData.luntan_lihuishijian"
                         placeholder=""/>
              </a-form-item>
            </a-col>
          </a-row>


          <a-divider>七彩星级国培</a-divider>

          <a-row :gutter="48">

            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="最高等级证明"
                  hasFeedback
              >
                <pic-uploader
                    :numberLimit="6"
                    :file-list="formData.grade_pics"
                />
              </a-form-item>
            </a-col>
 

            <a-col :md="12" :sm="24" v-if="formData.exame_video1.length>0">
              <a-form-item
                      label="考试1视频"
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
              >
                  <video-uploader :file-list="formData.exame_video1" numberLimit="1"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24" v-if="formData.exame_video2.length>0">
              <a-form-item
                      label="考试2视频"
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
              >
                  <video-uploader :file-list="formData.exame_video2" numberLimit="1"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24" v-if="formData.exame_video3.length>0">
              <a-form-item
                      label="考试3视频"
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
              >
                  <video-uploader :file-list="formData.exame_video3" numberLimit="1"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24" v-if="formData.exame_video3.length>0">
              <a-form-item
                      label="考试4视频"
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
              >
                  <video-uploader :file-list="formData.exame_video4" numberLimit="1"/>
              </a-form-item>
            </a-col>

          </a-row>



          <a-divider>人员信息
            <a-icon @click="memberEditVisible=true" type="edit"/>
            </a-divider>
          <a-table :columns="subjectColumns" :data-source="formData.member_list" :pagination="false">
            <p slot="extra_field" slot-scope="record" style="margin: 0">
            </p>
            <p slot="name" slot-scope="text,record">
              {{ record.name }} ({{ record.sex }})
              <br/>
              {{ record.num }}
              <br/>
              <span v-show="record.chengji">成绩：{{ record.chengji }}</span>
              <span v-show="record.cpj_chengji">裁判长成绩：{{ record.cpj_chengji }}</span>
            </p>
            <p slot="service" slot-scope="text,record">
              ({{ record.service_name }}) ¥{{ record.price }}
            </p>
            <template slot="action" slot-scope="text,record,index">
              <a href="javascript:;" @click="onEditUser(record)">编辑</a>
              <a-divider type="vertical"/>

                  <a-popconfirm title="删除后不可恢复,确定删除吗?" @confirm="onDeleteUser(record)" okText="确定" cancelText="取消">
                    <a href="javascript:;"  >删除</a>   
                     </a-popconfirm>
            </template>
          </a-table>

          <a-divider>发票信息</a-divider>
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="抬头"
                  hasFeedback
              >
                <a-input v-model="formData.fapiao_taitou"
                         placeholder="请输入抬头"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="税号"
                  hasFeedback
              >
                <a-input v-model="formData.fapiao_shuihao"
                         placeholder="请输入税号"/>
              </a-form-item>

            </a-col>
          </a-row>
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="发票备注"
                  hasFeedback
              >
                <a-input v-model="formData.fapiao_beizhu"
                         placeholder="请输入发票备注"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="接收邮箱"
                  hasFeedback
              >
                <a-input v-model="formData.fapiao_email"
                         placeholder="请输入接收邮箱"/>
              </a-form-item>

            </a-col>
          </a-row>
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="接收手机"
                  hasFeedback
              >
                <a-input v-model="formData.fapiao_phone"
                         placeholder="请输入接收手机"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
            </a-col>
          </a-row>


          <a-table :columns="fapiaoColumns" :data-source="formData.fapiao_list" :pagination="false">
            <p slot="extra_field" slot-scope="record" style="margin: 0">
            </p>
            <p slot="name" slot-scope="text,record">
              {{ record.fapiao_taitou }}
              <a-tag color="red" v-if="record.fapiao_type==2">红票</a-tag>
              <br/>
              {{ record.fapiao_shuihao }}
              <br/>
              {{ record.create_time|timeFormat }}
            </p>
            <div slot="fapiao" slot-scope="text,record">
              发票代码 {{ record.invoiceCode }}
              <br/>
              发票号码 {{ record.invoiceNum }}
              <br/>
              发票备注 {{ record.fapiao_beizhu }}
              <p v-if="record.error_msg">错误信息 {{ record.error_msg }}</p>
            </div>
            <p slot="status" slot-scope="text,record">
              <a-tag v-if="record.status==1">开票中</a-tag>
              <a-tag color="orange" v-if="record.status==-1">申请开票</a-tag>
              <a-tag color="green" v-if="record.status==2">开票成功</a-tag>
              <a-tag color="red" v-if="record.status==3">开票失败</a-tag>
              <a-tag v-if="record.status==4">作废中</a-tag>
              <a-tag color="purple" v-if="record.status==5">已作废</a-tag>
              <a-tag color="red" v-if="record.status==6">作废失败</a-tag>
            </p>
            <template slot="action" slot-scope="text,record,index">
              <a v-if="(record.status==2||record.status==4||record.status==5||record.status==6)" href="javascript:;"
                 @click="onFapiaoDownload(record)">下载</a>
              <span v-if="record.status==2&&record.fapiao_type==1">
                <a-divider type="vertical"/>
                  <a-popconfirm title="作废后不可恢复,确定作废吗?" @confirm="onFapiaoZuofei(record)" okText="确定" cancelText="取消">
                        <a href="javascript:;">作废</a>
                  </a-popconfirm>
              </span>

<!--              <span v-if="record.status==2&&record.fapiao_type==1">-->
              <span>
                  <a-popconfirm title="确定开出发票吗?" v-if="record.status==-1" @confirm="onKaipiao(record)" okText="确定" cancelText="取消">
                        <a href="javascript:;">确定开票</a>
                  </a-popconfirm>
                <a-divider type="vertical"/>
                  <a-popconfirm title="删除后不可恢复,确定删除吗?" @confirm="onFapiaoDelete(record)" okText="确定" cancelText="取消">
                        <a href="javascript:;">删除</a>
                  </a-popconfirm>
              </span>

              <span v-if="record.status==1||record.status==3">
                <a-divider type="vertical"/>
                <a href="javascript:;" @click="onRefreshFapiao(record)">刷新</a>
              </span>
            </template>
            <template slot="footer">
              <a-button @click="onFaipiaoApplyShow">
                新增开票
              </a-button>
              <a-button style="margin-left:8px" @click="onFaipiaoShenqingApplyShow">
                申请开票
              </a-button>
            </template>
          </a-table>

          <a-divider>操作日志</a-divider>
          <a-timeline>
            <a-timeline-item v-for="log in formData.loglist" :key="log.id">
              {{ log.create_time|timeFormat }}
              <b>{{ log.user_name }}</b>
              {{ log.title }}
              <span v-if="log.note" class="gray">备注:{{ log.note }}</span>
            </a-timeline-item>
          </a-timeline>
        </a-form>

      </a-spin>
      <template slot="footer">
        <a-button key="cancel" @click="handleCancel">取消</a-button>
        <a-button key="forward" :loading="saveLoading" type="primary" @click="handleOk">保存</a-button>
      </template>
    </a-modal>


    <a-modal
        :maskClosable="false"
        title="操作"
        :width="1200"
        :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
        v-model="orderVisible"
        @ok="handleOrderOk"
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form">
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="单位"
                  hasFeedback
              >
                {{ orderFormData.danwei }}
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="联系人"
                  hasFeedback
              >
                {{ orderFormData.ldname }}
              </a-form-item>
            </a-col>
          </a-row>

          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="应付"
                  hasFeedback
              >
                <a-input v-model="orderFormData.pay_price" allowClear placeholder="应付金额"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="支付单号"
                  hasFeedback
              >
                {{ orderFormData.out_trade_no ? orderFormData.out_trade_no : '无' }}
              </a-form-item>
            </a-col>
          </a-row>


          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="线上实付"
                  hasFeedback
              >
                {{ orderFormData.payed_price }}
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="线上支付时间"
                  hasFeedback
              >
                {{ orderFormData.pay_time_str }}
                <br/> {{orderFormData.pay_type_name}} {{orderFormData.pay_company}}
                {{orderFormData.out_trade_no}}  
              </a-form-item>
            </a-col>
          </a-row>

          <a-row>
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="支付状态"
                  hasFeedback
              >
                <a-radio-group v-model="orderFormData.status" button-style="solid">
                  <a-radio-button :value="1">
                    未支付
                  </a-radio-button>
                  <a-radio-button :value="2">
                    支付成功
                  </a-radio-button>
                </a-radio-group>

              </a-form-item>
            </a-col>

            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="支付凭证"
                  hasFeedback
              >
                <pic-uploader
                    :file-list="orderFormData.pics"
                />
              </a-form-item>
            </a-col>

          </a-row>

          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="支付方式"
                  hasFeedback
              >
                {{ orderFormData.pay_type_name }}
              </a-form-item>
            </a-col>

            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="退款金额"
                  hasFeedback
              >
                <a-input style="width: 70%; margin-right: 10px" :disabled="true" v-model="orderFormData.refund_price"
                         allowClear placeholder="应付金额"/>
                <br/>
                <div>
                  <a-tag color="red" v-if='orderFormData.refund_apply_comment'>
                    申请理由：{{ orderFormData.refund_apply_comment }}
                  </a-tag>
                </div>
                <a-button v-show="orderFormData.is_caiwu_admin" @click="onRefund('')">在线退款</a-button>
                <a-button v-show="orderFormData.is_caiwu_admin&&orderFormData.refund_status==2" @click="onRefundRefuse('')">
                  不处理
                </a-button>
                <a-button v-show="!orderFormData.is_caiwu_admin" @click="onRefundApply('')">申请退款</a-button>
              </a-form-item>
            </a-col>
          </a-row>


          <a-row :gutter="48">
            <a-col :md="12" :sm="24"> 
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="线下付款时间"
                  hasFeedback
              >
                <a-input v-model="orderFormData.pay_off_date" allowClear placeholder="线下付款时间"/>
              </a-form-item>
            </a-col>

            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="线下付款订单号"
                  hasFeedback
              >
                <a-input v-model="orderFormData.pay_off_id" allowClear placeholder="线下付款订单号"/>
              </a-form-item>
            </a-col>
          </a-row>

          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="线下实收"
                  hasFeedback
              >
                <a-input v-model="orderFormData.payed_price_offline" allowClear placeholder="线下实收"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="线下收款账户"
                  hasFeedback
              >
                <a-input v-model="orderFormData.pay_off_account" allowClear placeholder="线下收款账户"/>
                <br/>
              </a-form-item>
            </a-col>
          </a-row>


          <a-row>
            <a-col :md="48" :sm="24">
              <a-form-item
                  :labelCol="{
          xs: { span: 12 },
          sm: { span: 4 }}"
                  :wrapperCol="{
          xs: { span: 24 },
          sm: { span: 12 }}"
                  label="管理员备注"
                  hasFeedback
              >
                <a-textarea v-model="orderFormData.adminnote" placeholder="" auto-size/>
              </a-form-item>
            </a-col>
          </a-row>


          <a-divider>接送站费用</a-divider>


          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="应付"
                  hasFeedback
              >
                <a-input v-model="orderFormData.jiesong_pay_price" allowClear placeholder="应付金额"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="支付单号"
                  hasFeedback
              >
                {{ orderFormData.jiesong_out_trade_no ? orderFormData.jiesong_out_trade_no : '无' }}
              </a-form-item>
            </a-col>
          </a-row>


          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="线上实付"
                  hasFeedback
              >
                {{ orderFormData.jiesong_payed_price }}
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="线上支付时间"
                  hasFeedback
              >
                {{ orderFormData.jiesong_pay_time_str }}
                <br/> {{orderFormData.jiesong_pay_type_name}} {{orderFormData.jiesong_pay_company}}
                {{orderFormData.jiesong_out_trade_no}}  
              </a-form-item>
            </a-col>
          </a-row>

          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="支付方式"
                  hasFeedback
              >
                {{ orderFormData.jiesong_pay_type_name }}
              </a-form-item>
            </a-col>

            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="退款金额"
                  hasFeedback
              >
                <a-input style="width: 70%; margin-right: 10px" :disabled="true" v-model="orderFormData.jiesong_refund_price"
                         allowClear placeholder=""/>
                <br/>
                <div>
                  <a-tag color="red" v-if='orderFormData.jiesong_refund_apply_comment'>
                    申请理由：{{ orderFormData.jiesong_refund_apply_comment }}
                  </a-tag>
                </div>
                <a-button v-show="orderFormData.is_caiwu_admin" @click="onRefund('jiesong')">在线退款</a-button>
                <a-button v-show="orderFormData.is_caiwu_admin&&orderFormData.jiesong_refund_status==2" @click="onRefundRefuse('jiesong')">
                  不处理
                </a-button>
                <a-button v-show="!orderFormData.is_caiwu_admin" @click="onRefundApply('jiesong')">申请退款</a-button>
              </a-form-item>
            </a-col>
          </a-row>

        </a-form>

      </a-spin>
      <template slot="footer">
        <a-button key="cancel" @click="handleOrderCancel">取消</a-button>
        <a-button key="forward" :loading="saveLoading" type="primary" @click="handleOrderOk">保存</a-button>
      </template>
    </a-modal>


    <a-modal
        :maskClosable="false"
        title="人员操作"
        :width="1000"
        :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
        v-model="userFormVisible"
        @ok="handleUserFormOk"
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form3">
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="姓名"
                  hasFeedback
              >
                <a-input v-decorator="[
              'name',
              {rules: [{ required: true, message: '请输入姓名' }]}
            ]"
                         placeholder="请输入姓名"/>
              </a-form-item>
            </a-col>

            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="身份证"
                  hasFeedback
              >
                <a-input v-decorator="[
              'num',
              {rules: [{ required: true, message: '请输入身份证' }]}
            ]"
                         placeholder="请输入身份证"/>
              </a-form-item>
            </a-col>
          </a-row>

          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="性别"
                  hasFeedback
              >
                <a-input v-decorator="[
              'sex',
              {rules: [{ required: true, message: '请输入性别' }]}
            ]"
                         placeholder="请输入性别"/>
              </a-form-item>
            </a-col>

            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="手机"
                  hasFeedback
              >
                <a-input v-decorator="[
              'phone',
              {rules: [{ required: true, message: '请输入手机' }]}
            ]"
                         placeholder="请输入手机"/>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="成绩"
                  hasFeedback
              >
                <a-input v-decorator="[
              'chengji',
              {rules: [ ]}
            ]"
                         placeholder="请输入成绩"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="裁判长成绩"
                  hasFeedback
              >
                <a-input v-decorator="[
              'cpj_chengji',
              {rules: [ ]}
            ]"
                         placeholder="请输入裁判长成绩"/>
              </a-form-item>
            </a-col>
          </a-row>


          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="服务套餐"
                  hasFeedback
              >

                <a-select
                    showSearch
                    optionFilterProp="title"
                    v-model="userFormData.service_id"
                    placeholder="选择服务套餐"
                    allowClear
                >
                  <a-select-option v-for="(option,index) in serviceTypeOptions" :value="option.id">{{ option.name }}
                  </a-select-option>

                </a-select>

              </a-form-item>
            </a-col>

          </a-row>

          <a-divider>附加信息</a-divider>


          <a-row :gutter="48"> 

            <a-col :md="12" :sm="24" :key="k" v-for="(field,k) in userFormData.jsondata" v-show="!isPic(userFormData.jsondata[k])&&!isCheckBox(userFormData.jsondata[k])">
              <a-form-item
                  :label="k"
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
              >
                <a-input v-model="userFormData.jsondata[k]" placeholder="请输入附加信息值"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24" :key="k" v-for="(field,k) in userFormData.jsondata" v-show="isPic(userFormData.jsondata[k])">
              <a-form-item
                  :label="k"
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
              >
              
                <pic-uploader
                    :numberLimit="1"
                    :file-list="userFormData.jsondata[k]"
                /> 
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24" :key="k" v-for="(field,k) in userFormData.jsondata" v-show="isCheckBox(userFormData.jsondata[k])">
              <a-form-item
                  :label="k"
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
              >
               {{userFormData.jsondata[k]}}
              </a-form-item>
            </a-col>
          </a-row>

          <a-divider>接送站信息</a-divider>

          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="是否接站"
                  hasFeedback
              >
              <r-switch  :formData="userFormData" field="need_jie" :checkedValue="1" :unCheckedValue="2" checkedChildren="是" unCheckedChildren="否" />
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24" v-show="userFormData.need_jie==1">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="接站车次/航班"
                  hasFeedback
              >
                <a-input v-decorator="[
              'jie_code',
              {rules: [ ]}
            ]"
                         placeholder="请输入接站车次/航班"/>
              </a-form-item>
            </a-col>
          </a-row>

          <a-row :gutter="48"  v-show="userFormData.need_jie==1">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="接站时间"
                  hasFeedback
              >
                <a-input v-decorator="[
              'jie_date',
              {rules: [ ]}
            ]"
                         placeholder="请输入接站时间"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="接站额外人数"
                  hasFeedback
              >
                <a-input v-decorator="[
              'jie_count',
              {rules: [ ]}
            ]"
                         placeholder="请输入接站额外人数"/>
              </a-form-item>
            </a-col>
          </a-row>


 


          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="是否送站"
                  hasFeedback
              >
              <r-switch  :formData="userFormData" field="need_song" :checkedValue="1" :unCheckedValue="2" checkedChildren="是" unCheckedChildren="否" />
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24" v-show="userFormData.need_song==1">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="送站车次/航班"
                  hasFeedback
              >
                <a-input v-decorator="[
              'song_code',
              {rules: [ ]}
            ]"
                         placeholder="请输入送站车次/航班"/>
              </a-form-item>
            </a-col>
          </a-row>

          <a-row :gutter="48"  v-show="userFormData.need_song==1">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="送站时间"
                  hasFeedback
              >
                <a-input v-decorator="[
              'song_date',
              {rules: [ ]}
            ]"
                         placeholder="请输入送站时间"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="送站额外人数"
                  hasFeedback
              >
                <a-input v-decorator="[
              'song_count',
              {rules: [ ]}
            ]"
                         placeholder="请输入送站额外人数"/>
              </a-form-item>
            </a-col>
          </a-row>



          <a-divider>申报信息</a-divider>


          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="已有裁判等级（舞蹈）"
                  hasFeedback
              >
                <a-input
                    v-model="userFormData.caipandengjiwudao"
                    placeholder=""/>
              </a-form-item>
            </a-col>

            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="申报裁判等级（舞蹈）"
                  hasFeedback
              >
                <a-input
                    v-model="userFormData.caipanshenbaowudao"
                    placeholder=""/>
              </a-form-item>
            </a-col>
          </a-row>

          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="已有裁判等级（技巧）"
                  hasFeedback
              >
                <a-input
                    v-model="userFormData.caipandengjijiqiao"
                    placeholder=""/>
              </a-form-item>
            </a-col>

            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="申报裁判等级（技巧）"
                  hasFeedback
              >
                <a-input
                    v-model="userFormData.caipanshenbaojiqiao"
                    placeholder=""/>
              </a-form-item>
            </a-col>
          </a-row>


          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="已有教练等级（舞蹈）"
                  hasFeedback
              >
                <a-input
                    v-model="userFormData.jiaoliandengjiwudao"
                    placeholder=""/>
              </a-form-item>
            </a-col>

            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="申报教练等级（舞蹈）"
                  hasFeedback
              >
                <a-input
                    v-model="userFormData.jiaolianshenbaowudao"
                    placeholder=""/>
              </a-form-item>
            </a-col>
          </a-row>


          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="已有教练等级（技巧）"
                  hasFeedback
              >
                <a-input
                    v-model="userFormData.jiaoliandengjijiqiao"
                    placeholder=""/>
              </a-form-item>
            </a-col>

            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="申报教练等级（技巧）"
                  hasFeedback
              >
                <a-input
                    v-model="userFormData.jiaolianshenbaojiqiao"
                    placeholder=""/>
              </a-form-item>
            </a-col>
          </a-row>

          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="已有培训师"
                  hasFeedback
              >
                <a-input
                    v-model="userFormData.peixunshi"
                    placeholder=""/>
              </a-form-item>
            </a-col>

            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="申报培训师"
                  hasFeedback
              >
                <a-input
                    v-model="userFormData.peixunshishenbao"
                    placeholder=""/>
              </a-form-item>
            </a-col>
          </a-row>



          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="已有考官"
                  hasFeedback
              >
                <a-input
                    v-model="userFormData.kaoguan"
                    placeholder=""/>
              </a-form-item>
            </a-col>

            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="申报考官"
                  hasFeedback
              >
                <a-input
                    v-model="userFormData.kaoguanshenbao"
                    placeholder=""/>
              </a-form-item>
            </a-col>
          </a-row>


          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="已有导师"
                  hasFeedback
              >
                <a-input
                    v-model="userFormData.daoshi"
                    placeholder=""/>
              </a-form-item>
            </a-col>

            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="申报导师"
                  hasFeedback
              >
                <a-input
                    v-model="userFormData.daoshishenbao"
                    placeholder=""/>
              </a-form-item>
            </a-col>

          </a-row>


        </a-form>
      </a-spin>

      <template slot="footer">
        <a-button key="cancel" @click="handleUserFormCancel">取消</a-button>
        <a-button key="forward" :loading="saveLoading" type="primary" @click="handleUserFormOk">保存</a-button>
      </template>
    </a-modal>


    <a-modal
        :maskClosable="false" v-model="refundVisible"
        title="操作"
        :width="800"
        @ok="handleOrderOk"
    >
      <a-spin :spinning="saveLoading">

        <a-form-item
        v-if="!refund_type"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
            label="退款金额"
            :extra="'已退款'+orderFormData.refund_price+'元，还可退款'+(orderFormData.payed_price-orderFormData.refund_price)+'元'"
            hasFeedback
        >
          <a-input v-model="refund_price" placeholder=""/>
        </a-form-item>

        <a-form-item
        v-else
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
            label="退款金额"
            :extra="'已退款'+orderFormData.jiesong_refund_price+'元，还可退款'+(orderFormData.jiesong_payed_price-orderFormData.jiesong_refund_price)+'元'"
            hasFeedback
        >
          <a-input v-model="refund_price" placeholder=""/>
        </a-form-item>

        <a-form-item
            label="理由"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
        >
          <a-input
              v-model="refund_comment"
              placeholder="请输入理由"/>
        </a-form-item>

        <a-form-item
            label="密码"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
        >
          <a-input
              type="password"
              v-model="refund_mima"
              placeholder="请输入密码"/>
        </a-form-item>

      </a-spin>
      <template slot="footer">
        <a-button key="cancel" @click="handleRefundCancel">取消</a-button>
        <a-button key="forward" :loading="saveLoading" type="primary" @click="handleRefundOk">确定</a-button>
      </template>
    </a-modal>

    <a-modal
        v-model="refundApplyVisible"
        title="申请退款"
        :width="800"
        @ok="handleRefundApplyOk"
    >
      <a-spin :spinning="saveLoading">

        <a-form-item
            label="备注"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
        >
          <a-textarea
              v-model="refund_apply_comment"
              placeholder="请输入申请退款理由/单号/时间等"/>
        </a-form-item>
      </a-spin>
      <template slot="footer">
        <a-button key="cancel" @click="handleRefundApplyCancel">取消</a-button>
        <a-button key="forward" :loading="saveLoading" type="primary" @click="handleRefundApplyOk">确定</a-button>
      </template>
    </a-modal>

    <a-modal title="新增开票" :width="1000" v-model="kaipiaoVisible">
      <a-spin :spinning="saveLoading">
        <a-form :form="fapiaoForm">
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="抬头"
                  hasFeedback
              >
                <a-input v-decorator="[
          'fapiao_taitou',
          {rules: [{ required: true, message: '请输入抬头' }]}
        ]"
                         placeholder="请输入抬头"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="税号"
                  hasFeedback
              >
                <a-input v-decorator="[
          'fapiao_shuihao',
          {rules: [{ required: true, message: '请输入税号' }]}
        ]" placeholder="请输入税号"/>
              </a-form-item>
            </a-col>
          </a-row>

          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="图片链接"
                  hasFeedback
              >
                <a-input v-decorator="[
          'pic_url',
          {rules: [{ required: true, message: '请输入图片链接' }]}
        ]"
                         placeholder="请输入图片链接"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="PDF文件链接"
                  hasFeedback
              >
                <a-input v-decorator="[
          'pdf_url',
          {rules: [{ required: true, message: '请输入PDF链接' }]}
        ]"
                         placeholder="请输入PDF文件F链接"/>
              </a-form-item>
            </a-col>
          </a-row>

          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="发票号码"
                  hasFeedback
              >
                <a-input v-decorator="[
          'invoiceNum',
          {rules: [{ required: false, message: '请输入发票号码' }]}
        ]"
                         placeholder="请输入发票号码"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="发票代码"
                  hasFeedback
              >
                <a-input v-decorator="[
          'invoiceCode',
          {rules: [{ required: false, message: '请输入发票代码' }]}
        ]"
                         placeholder="请输入发票代码"/>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="发票备注"
                  hasFeedback
              >
                <a-input  v-decorator="[
          'fapiao_beizhu',
          {rules: [{ required: false, message: '请输入发票备注' }]}
        ]"
                         placeholder="请输入发票备注"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="接收邮箱"
                  hasFeedback
              >
                <a-input   v-decorator="[
          'fapiao_email',
          {rules: [{ required: false, message: '请输入接收邮箱' }]}
        ]"  
                         placeholder="请输入接收邮箱"/>
              </a-form-item>

            </a-col>
          </a-row>
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="接收手机"
                  hasFeedback
              >
                <a-input  v-decorator="[
          'fapiao_phone',
          {rules: [{ required: false, message: '请输入接收手机' }]}
        ]"   
                         placeholder="请输入接收手机"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
            </a-col>
          </a-row>
        </a-form>
      </a-spin>
      <template slot="footer">
        <a-button key="cancel" @click="kaipiaoVisible = false">取消</a-button>
        <a-button key="forward" :loading="saveLoading" type="primary" @click="kaipiaoApplyOk">确定</a-button>
      </template>
    </a-modal>


    <a-modal title="申请开票" :width="1000" v-model="kaipiaoShenqingVisible">
      <a-spin :spinning="saveLoading">
        <a-form :form="fapiaoShenqingForm">
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="抬头"
                  hasFeedback
              >
                <a-input v-decorator="[
          'fapiao_taitou',
          {rules: [{ required: true, message: '请输入抬头' }]}
        ]"
                         placeholder="请输入抬头"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="税号"
                  hasFeedback
              >
                <a-input v-decorator="[
          'fapiao_shuihao',
          {rules: [{ required: true, message: '请输入税号' }]}
        ]" placeholder="请输入税号"/>
              </a-form-item>
            </a-col>
          </a-row>

          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="地址"
                  hasFeedback
              >
                <a-input v-decorator="[
          'fapiao_address',
          {rules: [{ required: false, message: '（非必填）发票购买方地址' }]}
        ]"
                         placeholder="（非必填）发票购买方地址"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="电话"
                  hasFeedback
              >
                <a-input v-decorator="[
          'fapiao_tel',
          {rules: [{ required: false, message: '（非必填）发票购买方电话' }]}
        ]"
                         placeholder="请输入（非必填）发票购买方电话"/>
              </a-form-item>
            </a-col>
          </a-row>

          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="开户行及账号"
                  hasFeedback
              >
                <a-input v-decorator="[
          'fapiao_account',
          {rules: [{ required: false, message: '请输入（非必填）发票购买方开户行及账号' }]}
        ]"
                         placeholder="请输入（非必填）发票购买方开户行及账号"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="备注"
                  hasFeedback
              >
                <a-input v-decorator="[
          'fapiao_beizhu',
          {rules: [{ required: false, message: '请输入备注' }]}
        ]"
                         placeholder="请输入备注"/>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="48">
            <a-col :md="12" :sm="24"> 
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="接收手机"
                  hasFeedback
              >
                <a-input  
                v-decorator="[
          'fapiao_phone',
          {rules: [{ required: false, message: '请输入接收手机' }]}
        ]" 
                         placeholder="请输入接收手机"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="接收邮箱"
                  hasFeedback
              >
                <a-input 
                v-decorator="[
          'fapiao_email',
          {rules: [{ required: false, message: '请输入接收邮箱' }]}
        ]" 
                         placeholder="请输入接收邮箱"/>
              </a-form-item>

            </a-col>
          </a-row>
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="发票总金额"
                  hasFeedback
              >{{
                formFapiaoShenqingData.total
              }}
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
            </a-col>
          </a-row>
        </a-form>


          <a-divider>发票明细 
          </a-divider>

          <a-table :columns="fapiaoItemColumns" :data-source="formFapiaoShenqingData.list" :pagination="false">
            <span slot="num" slot-scope="text,record">
              <template>
                    <!-- <a-input-number v-model="record.num" :min="0" @change="fapiaoMxNumChange" :max="record.num_max" /> -->
                    {{record.count}}
              </template>
            </span>
            <span slot="goodsName" slot-scope="text,record">
              <template> 
                    {{formFapiaoShenqingData.goodsName}}
              </template>
            </span>
              <span slot="price" slot-scope="text,record">
              <template>
                 {{(formFapiaoShenqingData.pay_price/record.count).toFixed(2)}}
                    <!-- <a-input-number v-model="record.total" :min="0"  @change="fapiaoMxTotalChange" :max="record.max" /> -->
              </template>
            </span>
              <span slot="pay_price" slot-scope="text,record">
              <template>
                 {{formFapiaoShenqingData.pay_price}}
                    <!-- <a-input-number v-model="record.total" :min="0"  @change="fapiaoMxTotalChange" :max="record.max" /> -->
              </template>
            </span>

          </a-table>



      </a-spin>
      <template slot="footer">
        <a-button key="cancel" @click="kaipiaoShenqingVisible = false">取消</a-button>
        <a-button key="forward" :loading="saveLoading" type="primary" @click="kaipiaoShenqingApplyOk">确定</a-button>
      </template>
    </a-modal>


    <a-modal
        :maskClosable="false"
        :footer="null"
        title="批量生成"
        v-model="taskInfoShow2"
    >
      <a-badge status="success" :text="'上传成功 '+(taskInfo2.scount)"/>
      <a-divider type="vertical"/>
      <a-badge status="error" :text="'上传失败 '+(taskInfo2.fcount)"/>
      <a-divider type="vertical"/>
      <a-badge status="processing" :text="'总数 '+(taskInfo2.members.length) "/>
      </p>
      <p v-show="taskInfo2.errors.length>0">存在以下错误</p>
      <div style="height: 300px; overflow:scroll;">
        <p v-for="error in taskInfo2.errors">{{ error }}</p> 
      </div>
      <a-progress :percent="taskInfo2.percent"/>
      </p>
    </a-modal>



    <a-modal
        :maskClosable="false"
        title="操作"
        :width="1200"
        :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
        v-model="msgShow"
        @ok="handleSendOk"
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form"> 

          <a-row>
            <a-col :md="48" :sm="24">
              <a-form-item
                  :labelCol="{
          xs: { span: 12 },
          sm: { span: 4 }}"
                  :wrapperCol="{
          xs: { span: 24 },
          sm: { span: 12 }}"
                  label="发送手机号(换行隔开)"
                  hasFeedback
              >
                <a-textarea v-model="msgFormData.phone" placeholder="" auto-size/>
              </a-form-item>
            </a-col>
          </a-row> 

        </a-form>

      </a-spin>
      <template slot="footer">
        <a-button key="cancel" @click="msgShow=false">取消</a-button>
        <a-button key="forward" :loading="saveLoading" type="primary" @click="handleSendOk">确认发送</a-button>
      </template>
    </a-modal>




    <a-modal title="扫码" v-model="memberEditVisible" @ok="memberEditVisible=false">
      <p style="text-align: center">
        <img :src="formData.member_edit_qr"/>
      </p>  
    </a-modal>

  </a-card>
</template>

<script>
import STable from '@/components/table/'
import ATextarea from 'ant-design-vue/es/input/TextArea'
import AInput from 'ant-design-vue/es/input/Input'
import EditableCell from '@/components/EditableCell/'
import PicUploader from '@/components/PicUploader/'
import FileUploader from '@/components/FileUploader/'
import JiaolianPicker from '@/components/JiaolianPicker/'
import RSwitch from '@/components/RSwitch/'
import CaipanPicker from '@/components/CaipanPicker/'
import areaOptions from '@/utils/area'
import moment from 'moment'
import XLSX from 'xlsx'
import qs from 'qs'
import setting from '@/config/setting'
import 'moment/locale/zh-cn';

moment.locale('zh-cn');

import {
  getApplyList,
  getApplyDetail,
  getServiceTypeList,
  editApply,
  applyDelete,
  sjsqOptions, 
  getApplyOrderDetail,
  editApplyOrder,
  fapiaoImport,
  getApplyUserDetail,
  editApplyUser,
  memberDelete,
  orderRefund,
  scoreImport,
  orderRefundApply,
  orderRefundRefuse,
  getKaipiaoItemList,
  fapiaoShenqingApply,
  fapiaoApply,
  applyImport,
  checkApplyOK,
  getHuiyiPhones,
  sendHuiyiMsg,
} from '@/api/huiyi'
import VideoUploader from '@/components/VideoUploader/'
import {fapiaoZuofei, refreshFapiao, fapiaoDelete,kaipiao} from '@/api/fapiao'

export default {
  name: 'KaojiApplyList',
  components: {
    AInput,
    ATextarea,
    FileUploader,
    PicUploader,
    STable,
    EditableCell, 
    CaipanPicker,
    JiaolianPicker,
    RSwitch,
    VideoUploader,
  },
  data() {
    return {
      areaOptions,
      kaipiaoVisible: false,
      refundVisible: false,
      refundApplyVisible: false,
      refund_price: '',
      refund_apply_comment: '',
      refund_type: '',
      refund_comment: '',
      refund_mima: '',
      visible: false,
      orderVisible: false,
      msgShow: false,
      saveLoading: false,
      userFormVisible: false,
      jiaolianPickerShow: false,
      caipanPickerShow: false,
      taskInfoShow2:false,
      sjsqOptions: [],
      msgFormData:{
        phone:''
      },
      orderFormData: {
        pics: [],
      },
      formData: {
        id: 0,
        danwei: '',
        areas: [],
        member_list: [],
        loglist: [],
        fapiao_list: [],
        lunwen_dazhaiyao: [],
        lunwen_content: [],
        exame_video1: [],
        exame_video2: [],
        exame_video3: [],
        exame_video4: [], 
        grade_pics: [], 
      },
      time_range_moment: [],
      time_range: [],
      labelCol: {
//          xs: { span: 24 },
//          sm: { span: 5 },
        xs: {span: 24},
        sm: {span: 8},
      },
      wrapperCol: {
        xs: {span: 24},
        sm: {span: 12},
      },
      memberEditVisible:false,
      form: this.$form.createForm(this),
      form3: this.$form.createForm(this),
      fapiaoForm: this.$form.createForm(this),
      fapiaoShenqingForm: this.$form.createForm(this),
      mdl: {},

      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {
        keywords: '',
        kaipiao_status:0,
        sjsq: []
      },
      // 表头
      columns: [
        {
          title: '#',
          dataIndex: 'id',
          width: '50px'
        },
        {
          title: '报名信息',
          dataIndex: 'danwei',
          scopedSlots: {customRender: 'danwei'},
        },
        {
          title: '场次',
          dataIndex: 'saiqu',
          scopedSlots: {
            customRender: 'saiqu' +
                ''
          },
        },
        {
          title: '进度',
          dataIndex: 'status',
          scopedSlots: {customRender: 'status'},
        },
        {
          title: '操作',
          dataIndex: 'action',
          fixed: 'right',
          width: 220,
          scopedSlots: {customRender: 'action'},
        }
      ],
      // 表头
      subjectColumns: [
        {
          title: '#',
          dataIndex: 'id',
          width: '50px'
        },
        {
          title: '姓名',
          dataIndex: 'name',
          scopedSlots: {customRender: 'name'},
        },
        {
          title: '电话',
          dataIndex: 'phone',
        },
        {
          title: '微信',
          dataIndex: 'weixin',
        },
        {
          title: '套餐',
          dataIndex: 'service',
          scopedSlots: {customRender: 'service'},
        },
        {
          title: '操作',
          dataIndex: 'action',
          fixed: 'right',
          width: 120,
          scopedSlots: {customRender: 'action'},
        }
      ],
      // 发票
      fapiaoColumns: [
        {
          title: '#',
          dataIndex: 'id',
          width: '50px'
        },
        {
          title: '抬头',
          dataIndex: 'fapiao_taitou',
          scopedSlots: {customRender: 'name'},
        },
        {
          title: '发票信息',
          dataIndex: 'fapiao',
          scopedSlots: {customRender: 'fapiao'},
        },
        {
          title: '状态',
          dataIndex: 'status',
          scopedSlots: {customRender: 'status'},
        },
        {
          title: '操作',
          dataIndex: 'action',
          fixed: 'right',
          width: 200,
          scopedSlots: {customRender: 'action'},
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        console.log('loadData');
        console.log(this.queryParam);
        let that = this;

        if (this.time_range_moment[0] && this.time_range_moment[1]) {
          this.queryParam.time_range = [
            this.time_range_moment[0].format('YYYY-MM-DD HH:mm:ss'),
            this.time_range_moment[1].format('YYYY-MM-DD HH:mm:ss')
          ]
        } else {
          this.queryParam.time_range = []
        }

        this.queryParam = Object.assign(this.queryParam, parameter);
        return getApplyList(this.queryParam)
            .then(res => {
              console.log('res');
              return res.data
            })
      },

      selectedRowKeys: [],
      selectedRows: [],
      cashFormData: {
        ids: [],
        to_type: '',
        price: 0,
        note: '',
        count: 0,
      },
      taskInfo2: {
        members: [],
        errors: [],
        currentIndex: 0,
        scount: 0,
        fcount: 0,
        percent: 0,
        doing: false,
      },
      serviceTypeOptions: [],
      userFormData: {
        id: 0,
        name: '',
        "caipandengjiwudao": "",
        "caipandengjijiqiao": "",
        "jiaoliandengjiwudao": "",
        "jiaoliandengjijiqiao": "",
        "caipanshenbaowudao": "",
        "caipanshenbaojiqiao": "",
        "jiaolianshenbaowudao": "",
        "jiaolianshenbaojiqiao": "",
        jsondata: []
      },

      kaipiaoShenqingVisible: false,
      formFapiaoShenqingData: {
        id: 0, 
        total:0,
        goodsName:'',
        pay_price:'',
        list: [],
      },
      fapiaoItemColumns:[
        {
          title: '名称',
          dataIndex: 'goodsName', 
          scopedSlots: {customRender: 'goodsName'},
        },
        {
          title: '单价',
          dataIndex: 'price', 
          scopedSlots: {customRender: 'price'},
        },
        {
          title: '数量',
          dataIndex: 'num', 
          scopedSlots: {customRender: 'num'},
        },
        {
          title: '小记',
          dataIndex: 'pay_price',
          scopedSlots: {customRender: 'pay_price'},
        },

      ],
    }
  },
  computed: {},

  created() {
  },

  mounted() {
    let that = this;

    let query = this.$route.query;
    // 6, 276
    console.log(query)
    if (query.saiji) {
      this.queryParam.sjsq = [query.saiji, query.saiqu]
    }
    that.getSjsqOptions();
  },
  methods: {
    moment,
    isPic(val){
      if( typeof val =='object' && val.length>0){
        if( typeof val[0].url == 'string' ){
          return true
        }
      } 
      return false;
    },
    isCheckBox(val){
      if( typeof val =='object' && val.length>0){
        if( typeof val[0] == 'string' ){
          return true
        }
      }  
      if( typeof val =='object' && val.length==0){ 
          return true 
      }  
      return false
    },
    getSjsqOptions() {
      let that = this;
      sjsqOptions({}).then(res => {
        that.sjsqOptions = res.data;
      });
    },
    handleCancel() {
      this.visible = false
    },
    handleOrderCancel() {
      this.orderVisible = false
    },
    //展开关闭
    toggleAdvanced() {
      this.advanced = !this.advanced
    },

    onFaipiaoApplyShow() {
      let self = this
      self.kaipiaoVisible = true

      // 赋值
      setTimeout(function () {
        self.fapiaoForm.setFieldsValue({...self.formData})
      }, 200)
    },
    kaipiaoApplyOk(e) {
      let self = this;
      e.preventDefault();

      this.fapiaoForm.validateFields((err, values) => {
        if (!err) {
          console.log('Received values of form: ', values)
          console.log('Received valuess of formData: ', self.formData)
          self.saveLoading = true;
          fapiaoApply({
            id: self.formData.id,
            fapiao_taitou: values.fapiao_taitou,
            fapiao_shuihao: values.fapiao_shuihao,
            pic_url: values.pic_url,
            pdf_url: values.pdf_url,
            invoiceNum: values.invoiceNum,
            invoiceCode: values.invoiceCode,
            fapiao_beizhu: values.fapiao_beizhu,
            fapiao_email: values.fapiao_email,
            fapiao_phone: values.fapiao_phone,
          }).then(res => {
            self.$message.success('新增成功')
            self.handleEdit(self.formData)
            self.saveLoading = false
            self.kaipiaoVisible = false
          }).catch(err => {
            self.$message.error(err.data.msg)
            self.saveLoading = false
          })
        }
      })

    },
    kaipiaoShenqingApplyOk(e) {
      let self = this;
      e.preventDefault();

      this.fapiaoShenqingForm.validateFields((err, values) => {
        if (!err) {
          console.log('Received values of form: ', values) 
          self.saveLoading = true;
          fapiaoShenqingApply({
            id: self.formData.id,
            fapiao_taitou: values.fapiao_taitou,
            fapiao_shuihao: values.fapiao_shuihao,
            fapiao_address: values.fapiao_address,
            fapiao_tel: values.fapiao_tel,
            fapiao_account: values.fapiao_account,
            fapiao_beizhu: values.fapiao_beizhu,
            fapiao_email: values.fapiao_email,
            fapiao_phone: values.fapiao_phone,
            list: self.formFapiaoShenqingData.list,
          }).then(res => {
            self.$message.success('申请提交成功')
            self.handleEdit(self.formData)
            self.saveLoading = false
            self.kaipiaoShenqingVisible = false
          }).catch(err => {
            self.$message.error(err.data.msg)
            self.saveLoading = false
          })
        }
      })

    },
    onFaipiaoShenqingApplyShow() {
      let self = this

      getKaipiaoItemList({
        id:this.formData.id
      })
      .then(res => {
        console.log('res');
        self.formFapiaoShenqingData.list =  res.data.list
        self.formFapiaoShenqingData.goodsName =  res.data.goodsName
        self.formFapiaoShenqingData.pay_price =  res.data.pay_price
        self.formFapiaoShenqingData.list.map(item =>{
          this.$set(item,'num_max',item.num); 
        })
      }) 


      self.kaipiaoShenqingVisible = true

      // 赋值
      setTimeout(function () {
        self.fapiaoShenqingForm.setFieldsValue({...self.formData})
      }, 200)
    },



    handleEdit(record) {
      let self = this
      this.visible = true
      getApplyDetail({id: record.id}).then(res => {
        setTimeout(() => {
          self.form.setFieldsValue({...res.data})
          self.formData.id = record.id;
          console.log('handleEdit')
          if (res.data.area) {
            res.data.areas = [res.data.area.substring(0, 2) + '0000', res.data.area.substring(0, 4) + '00', res.data.area];
          } else {
            res.data.areas = [];
          }
          self.formData = {...res.data};
        }, 200)
      })
      // console.log(this.mdl)
    },
    handleOrderEdit(record) {
      let self = this
      getApplyOrderDetail({baoming_id: record.id}).then(res => {
        self.orderVisible = true
        setTimeout(() => {
          self.orderFormData.id = record.id;
          console.log('handleEdit')

          self.orderFormData = {...res.data};
        }, 200)
      }).catch(err => {
        self.$message.error(err.data.msg);
      })
      // console.log(this.mdl)
    },
    // 查
    onSearch() {
      let self = this;
      self.$refs.table.refresh(false)
    },

    // 增改 处理
    handleOk(e) {
      let self = this;
      e.preventDefault()
      if (self.formData.areas.length != 3) {
        self.$message.error('请选择完整地区');
        return;
      }
      this.form.validateFields((err, values) => {
        if (!err) {
          console.log('Received values of form: ', values)
          console.log('Received valuess of formData: ', self.formData)
          self.saveLoading = true;
          editApply({
            id: self.formData.id,
            danwei: self.formData.danwei,
            ldname: self.formData.ldname,
            weixin: self.formData.weixin,
            email: self.formData.email,
            phone: self.formData.phone,
            fapiao_taitou: self.formData.fapiao_taitou,
            fapiao_shuihao: self.formData.fapiao_shuihao,
            fapiao_beizhu: self.formData.fapiao_beizhu,
            fapiao_email: self.formData.fapiao_email,
            fapiao_phone: self.formData.fapiao_phone,
            memberstatus: self.formData.memberstatus,

            lunwen_dazhaiyao: self.formData.lunwen_dazhaiyao,
            lunwen_content: self.formData.lunwen_content,
            lunwen_type: self.formData.lunwen_type,
            lunwen_title: self.formData.lunwen_title,

            luntan_lihuishijian: self.formData.luntan_lihuishijian,
            luntan_shoupai: self.formData.luntan_shoupai,

            area: self.formData.areas[self.formData.areas.length - 1],
            address: self.formData.address,
          }).then(res => {
            self.$message.success('修改成功')
            self.$refs.table.refresh()
            self.visible = false;
            self.saveLoading = false;
          }).catch(err => {
            self.$message.error(err.data.msg);
            self.saveLoading = false;
          })
        }
      })
    },
    // 增改 处理
    handleOrderOk(e) {
      let self = this;
      e.preventDefault();

      self.saveLoading = true;
      editApplyOrder({
        id: self.orderFormData.id,
        baoming_id: self.orderFormData.baoming_id,
        status: self.orderFormData.status,
        adminnote: self.orderFormData.adminnote,
        memberprice: self.orderFormData.memberprice,
        pay_price: self.orderFormData.pay_price,
        pics: self.orderFormData.pics,
        pay_off_account: self.orderFormData.pay_off_account,
        pay_off_date: self.orderFormData.pay_off_date,
        pay_off_id: self.orderFormData.pay_off_id,
        payed_price_offline: self.orderFormData.payed_price_offline,
      }).then(res => {
        self.$message.success('修改成功')
        self.$refs.table.refresh()
        self.orderVisible = false;
        self.saveLoading = false;
      }).catch(err => {
        self.$message.error(err.data.msg);
        self.saveLoading = false;
      })
    },

    // 删
    applyDelete(record) {
      let self = this
      applyDelete({id: record.id}).then(res => {
        self.$message.success('删除成功')
        self.$refs.table.refresh()
      }).catch(err => {
        self.$message.error(err.data.msg)
      })
    },
    // 删
    applyDeleteAll() {
      let self = this
      applyDelete({ids: self.selectedRowKeys, id: 0}).then(res => {
        self.$message.success('删除成功')
        self.$refs.table.refresh()
      }).catch(err => {
        self.$message.error(err.data.msg)
      })
    },
    onDeleteUser(record){
          let self = this;
          memberDelete({
            id: record.id, 
          }).then(res => {
            self.$message.success('删除成功') 
            self.handleEdit({id: self.formData.id});
          }).catch(err => {
            self.$message.error(err.data.msg); 
          })
    },

    onEditUser(record) {
      let self = this
      this.userFormVisible = true
      getApplyUserDetail({id: record.id}).then(res => {
        setTimeout(() => {
          self.form3.setFieldsValue({...res.data})
          self.userFormData.id = record.id;
          self.userFormData = {...res.data};
        }, 200)
      });
      getServiceTypeList({saiqu: self.formData.saiqu}).then(res => {
        setTimeout(() => {
          self.serviceTypeOptions = res.data
        }, 200)
      });
    },
    handleUserFormCancel() {
      this.userFormVisible = false
    },


    handleUserFormOk(e) {
      let self = this;
      e.preventDefault()
      this.form3.validateFields((err, values) => {
        if (!err) {
          console.log('Received values of form: ', values)
          console.log('Received valuess of formData: ', self.userFormData)
          self.saveLoading = true;
          editApplyUser({
            id: self.userFormData.id,
            name: values.name,
            num: values.num,
            phone: values.phone,
            chengji: values.chengji,
            cpj_chengji: values.cpj_chengji,
            sex: values.sex,
            service_id: self.userFormData.service_id,
            caipandengjiwudao: self.userFormData.caipandengjiwudao,
            caipandengjijiqiao: self.userFormData.caipandengjijiqiao,
            jiaoliandengjiwudao: self.userFormData.jiaoliandengjiwudao,
            jiaoliandengjijiqiao: self.userFormData.jiaoliandengjijiqiao,
            caipanshenbaowudao: self.userFormData.caipanshenbaowudao,
            caipanshenbaojiqiao: self.userFormData.caipanshenbaojiqiao,
            jiaolianshenbaowudao: self.userFormData.jiaolianshenbaowudao,
            jiaolianshenbaojiqiao: self.userFormData.jiaolianshenbaojiqiao,
            kaoguan: self.userFormData.kaoguan,
            kaoguanshenbao: self.userFormData.kaoguanshenbao,
            peixunshi: self.userFormData.peixunshi,
            peixunshishenbao: self.userFormData.peixunshishenbao,
            daoshi: self.userFormData.daoshi,
            daoshishenbao: self.userFormData.daoshishenbao,
            jsondata: self.userFormData.jsondata,
            need_jie: self.userFormData.need_jie,
            need_song: self.userFormData.need_song,
            jie_count: values.jie_count,
            jie_code: values.jie_code,
            jie_date: values.jie_date, 
            song_date: values.song_date, 
            song_code: values.song_code, 
            song_count: values.song_count, 
          }).then(res => {
            self.$message.success('修改成功')
            self.userFormVisible = false;
            self.saveLoading = false;
            self.handleEdit({id: self.formData.id});
          }).catch(err => {
            self.$message.error(err.data.msg);
            self.saveLoading = false;
          })

        }
      })
    },


    download(type) {
      console.log('this.queryParam')
      console.log(this.queryParam)
      let keys = JSON.stringify(this.selectedRowKeys)
      if (typeof this.queryParam.sjsq == 'undefined' || this.queryParam.sjsq.length != 2) {
        this.$message.error('请先选择场次');
        return;
      }
      switch (type) {
        case 1:
          window.open(setting.apiBaseURL + '/adminapi/huiyi/applyDownload?saiqu=' + qs.stringify(this.queryParam));
          break;
        case 2:
          window.open(setting.apiBaseURL + '/adminapi/huiyi/memberDownload?saiqu=' + qs.stringify(this.queryParam));
          break;
        case 3:
          window.open(setting.apiBaseURL + '/adminapi/huiyi/member331Download?saiqu=' + qs.stringify(this.queryParam));
          break;
        case 4:
          window.open(setting.apiBaseURL + '/adminapi/sai/csrstjDownload?saiqu=' + this.queryParam.sjsq[1]);
          break;
        case 5:
          window.open(setting.apiBaseURL + '/adminapi/sai/zhixuceDownload?saiqu=' + this.queryParam.sjsq[1] + '&memberstatus=' + (this.queryParam.memberstatus || 0));
          break;
        case 6:
          window.open(setting.apiBaseURL + '/adminapi/sai/caiwuDownload?saiqu=' + this.queryParam.sjsq[1]);
          break;
        case 9: 
            // return
          window.open(setting.apiBaseURL + '/adminapi/huiyi/fapiaoExport?saiqu=' + this.queryParam.sjsq[1] + '&keys=' + keys);
          break;

      }
    },
    onFapiaoDownload(record) {
      window.open(record.pdf_url);
    },
    onFapiaoZuofei(record) {
      let self = this
      fapiaoZuofei({id: record.id}).then(res => {
        self.handleEdit({id: record.baoming_id})
      }).catch(err => {
        self.$message.error(err.data.msg)
      })
    },

    // 删除发票
    onFapiaoDelete(record) {
      let self = this
      fapiaoDelete({id: record.id}).then(res => {
        self.handleEdit({id: record.baoming_id})
      }).catch(err => {
        self.$message.error(err.data.msg)
      })
    },
    onKaipiao(record) {
      let self = this
      kaipiao({id: record.id}).then(res => {
        self.handleEdit({id: record.baoming_id})
      }).catch(err => {
        self.$message.error(err.data.msg)
      })
    },
    onRefreshFapiao(record) {
      let self = this
      refreshFapiao({fapiao_id: record.id}).then(res => {
        self.handleEdit({id: record.baoming_id})
      }).catch(err => {
        self.$message.error(err.data.msg)
      })
    },

    onRefund(type) {
      this.refundVisible = true;
      this.refund_price = '';
      this.refund_comment = '';
      this.refund_type = type;
      this.refund_mima = '';
    },
    onRefundApply(type) {
      this.refundApplyVisible = true;
      this.refund_type = type;
      this.refund_apply_comment = ''; 
    },
    handleRefundCancel() {
      this.refundVisible = false;
      this.refund_price = '';
    },
    handleRefundApplyCancel() {
      this.refundApplyVisible = false;
      this.refund_apply_comment = ''; 
    },
    onRefundRefuse(type) {
      let self = this;
      orderRefundRefuse({
        order_id: self.orderFormData.id,
        jiesong_order_id: self.orderFormData.jiesong_order_id, 
        type: type
      }).then(res => {
        self.saveLoading = false;
        self.handleOrderEdit({
          id: self.orderFormData.baoming_id
        })
      }).catch(err => {
        self.saveLoading = false;
        self.$message.error(err.data.msg)
      })
    },
    handleRefundOk() {
      let self = this
      if (self.refund_price == 0) {
        self.$message.error('请输入退款金额')
        return;
      }
      if (self.refund_comment == '') {
        self.$message.error('请填写理由')
        return;
      }
      if (self.refund_mima == '') {
        self.$message.error('请填写密码')
        return;
      }
      self.saveLoading = true;
      orderRefund({
        jiesong_order_id: self.orderFormData.jiesong_order_id, 
        type: self.refund_type,
        order_id: self.orderFormData.id,
        price: self.refund_price,
        comment: self.refund_comment,
        password: self.refund_mima,
      }).then(res => {
        self.refundVisible = false;
        self.saveLoading = false;
        self.handleOrderEdit({
          id: self.orderFormData.baoming_id
        })
      }).catch(err => {
        self.saveLoading = false;
        self.$message.error(err.data.msg)
      })
    },
    handleRefundApplyOk() {
      let self = this
      if ( self.refund_apply_comment == '') {
        self.$message.error('请填写理由')
        return;
      } 
      self.saveLoading = true;
      orderRefundApply({
        jiesong_order_id: self.orderFormData.jiesong_order_id,
        order_id: self.orderFormData.id,
        type: self.refund_type,
        comment: self.refund_apply_comment, 
      }).then(res => {
        self.refundApplyVisible = false;
        self.saveLoading = false;
        self.handleOrderEdit({
          id: self.orderFormData.baoming_id
        })
      }).catch(err => {
        self.saveLoading = false;
        self.$message.error(err.data.msg)
      })
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },

    beforeUpload(file) {
      let that = this
      let formdata = new FormData()
      console.log(file)
      formdata.append('upfile', file)
      formdata.append('action', 'test')
      console.log('formdata', formdata)
      scoreImport(formdata)
          .then(res => {
            that.$message.success('上传成功')
            that.$refs.table.refresh(true)
          })
          .catch(err => {
            that.$message.error(err.data.msg)
          })
      return false // false就是不自动上传，我后来试了发现都一样，都不会自动上传
    },

    beforeApplyUpload(file) {
      let that = this;
      let formdata = new FormData();
      console.log(file);
      formdata.append("upfile", file);
      formdata.append("action", "test");
      console.log("formdata", formdata);
      if (this.queryParam.sjsq.length != 2) {
        that.$message.error('请先选择场次')
        return false;
      }

      this.file2Xce(file).then((tabJson) => {
        // console.log('this.xlsxJson', tabJson);
        if (tabJson && tabJson.length > 0) {
          // this.xlsxJson = tabJson
          console.log("this.xlsxJson", tabJson);
          // if (typeof tabJson[0].sheet[0].__EMPTY_12 == 'undefined' || tabJson[0].sheet[0].__EMPTY_12 != "版本2021001") {
          //   that.$message.error('文件版本不正确');
          //   return;
          // }

          // return ;

          let userList = [];
          tabJson[0].sheet.map((item, index) => {
            if (index >= 0 && item["身份证号"]) {  
                userList.push({
                  name: item["姓名"],
                  danwei: item["单位"]||'',
                  sex: item["性别"] || "",
                  num: item["身份证号"],
                  phone: item["联系电话"] || "",
                  身高: item["身高（CM）"] || "",
                  鞋码: item["鞋子尺码"] || "", 
                  体重: item["体重（KG）"] || "", 
                });
            }
          });

          // console.log('userList', userList);
          // return ;

          that.taskInfo2 = {
            members: userList,
            currentIndex: 0,
            scount: 0,
            fcount: 0,
            errors: [],
            doing: true,
          };
          that.taskInfoShow2 = true;
          that.doTask2(that.taskInfo2);
        }
      });
 
      return false; // false就是不自动上传，我后来试了发现都一样，都不会自动上传
    },


    doTask2(taskInfo) {
      let that = this;
      if (taskInfo.currentIndex >= taskInfo.members.length) {
        taskInfo.doing = false;
        //结束
        if (taskInfo.fcount == 0) {
          applyImport({
            list: JSON.stringify(taskInfo.members),
            saiqu: that.queryParam.sjsq[1], 
          }).then((res) => {
            that.taskInfoShow2 = false;
            that.$message.success("上传成功");
            that.$refs.table.refresh(true);
          });
        }
        return false;
      }
      if(!taskInfo.members[taskInfo.currentIndex].namekey){
            // that.taskInfoShow2 = false;
            // that.$message.error('管理端上传省市代码那列不能为空')
            // return ;
      }
      checkApplyOK({
        name: taskInfo.members[taskInfo.currentIndex].name,
        num: taskInfo.members[taskInfo.currentIndex].num, 
        saiqu: that.queryParam.sjsq[1], 
      })
        .then((res) => {
          if (res.data.length > 0) {
            taskInfo.fcount++;
            taskInfo.errors = taskInfo.errors.concat(res.data);
            taskInfo.currentIndex++;
          } else {
            taskInfo.scount++;
            taskInfo.currentIndex++;
            console.log(taskInfo.currentIndex);
            if (taskInfo.currentIndex == taskInfo.members.length) {
            }
          }
          taskInfo.percent = (
            (taskInfo.currentIndex / taskInfo.members.length) *
            100
          ).toFixed(1);
          that.doTask2(taskInfo);
        })
        .catch((err) => {
          console.log('err',err)
          taskInfo.fcount++;
          taskInfo.currentIndex++;
          taskInfo.percent = (
            (taskInfo.currentIndex / taskInfo.members.length) *
            100
          ).toFixed(1);
          that.doTask2(taskInfo);
        });
    },

    sjsqFilter(inputValue, path) {
      return path.some(option => option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1);
    },

    beforeFapiaoUpload(file) {
      let that = this
      let formdata = new FormData()
      console.log(file)
      formdata.append('upfile', file)
      formdata.append('action', 'test')
      console.log('formdata', formdata)

      let fapiaoList = [];
      this.file2Xce(file).then(tabJson => {
        if (tabJson && tabJson.length > 0) {
          // this.xlsxJson = tabJson
          console.log('this.xlsxJson', tabJson);
          // return ;
          tabJson[0].sheet.map((item, index) => {
            // console.log(item,index);
            if (item['pdf网址']) { 
              fapiaoList.push({ 
                fapiao_id: item['发票id']||'',
                baoming_id: item['报名id']||'', 
                fapiao_taitou: item['抬头']||'',
                fapiao_shuihao: item['税号']||'',
                fapiao_tel: item['电话']||'',
                fapiao_address: item['地址']||'',
                fapiao_account: item['开户行及账号']||'',
                fapiao_beizhu: item['备注']||'',
                invoiceCode: item['发票代码']||'',
                invoiceNum: item['发票号码']||'',
                pdf_url: item['pdf网址']||'',
              });
            }
          })

          console.log('fapiaoList', fapiaoList);
          // return

          fapiaoImport({
            list:JSON.stringify(fapiaoList)
          })
            .then(res => {
              that.$message.success('上传成功')
              that.$refs.table.refresh(false)
            })
            .catch(err => {
              that.$message.error(err.data.msg)
            })
 
        }
      });

      // return ;

      
      return false // false就是不自动上传，我后来试了发现都一样，都不会自动上传
    },

    file2Xce(file) {
      return new Promise(function (resolve, reject) {
        const reader = new FileReader()
        reader.onload = function (e) {
          const data = e.target.result
          this.wb = XLSX.read(data, {
            type: 'binary'
          })
          const result = []
          this.wb.SheetNames.forEach((sheetName) => {
            result.push({
              sheetName: sheetName,
              sheet: XLSX.utils.sheet_to_json(this.wb.Sheets[sheetName])
            })
          })
          resolve(result)
        }
        // reader.readAsBinaryString(file.raw)
        reader.readAsBinaryString(file) // 传统input方法
      })
    },
    handleSendOk(){
      let that = this;
      that.saveLoading=true;
      sendHuiyiMsg(that.msgFormData)
          .then(res => { 
            console.log(res)
            that.$message.success('发送成功')
            that.msgShow = false
            that.saveLoading=false;
          })
          .catch(err => {
            that.saveLoading=false;
            that.$message.error(err.data.msg)
          })
    },
    onSendMsg( val ){
      console.log('val',val)
      let baoming_id = 0;
      let saiqu = 0;
      let that = this;
      if(val.baoming_id>0){
        baoming_id = val.baoming_id
        saiqu = 0;
      }else if(val.sjsq.length<2){
          that.$message.error('请先选择场次')
          return 
      }else{
        baoming_id = 0
        saiqu = val.sjsq[1];
      }
      
      getHuiyiPhones({
        baoming_id,saiqu
      })
          .then(res => { 
            console.log(res)
            that.msgFormData.phone = res.data.phone
            that.msgFormData.saiqu = res.data.saiqu
            that.msgShow = true
          })
          .catch(err => {
            that.$message.error(err.data.msg)
          })
    }

  },
  filters: {},
  watch: {}
}
</script>
